<template>
  <v-list class="pre-list">
    <v-list-item :to="{ name: 'collectionPoint.detail', params: { id: $route.params.id } }">
      <v-list-item-content>Odběrné místo</v-list-item-content>
    </v-list-item>

    <v-list-item
      :to="{ name: 'reportReading.detail', params: { id: $route.params.id } }"
      v-if="
        collectionPoint.voltageLevel === 'NN' ||
          (collectionPoint.allowedInstallationAction &&
            collectionPoint.allowedInstallationAction.name === 'READING')
      "
    >
      <v-list-item-content>Nahlášení odečtu</v-list-item-content>
    </v-list-item>

    <v-list-item
      :to="{
        name: routeType + '.detail',
        params: { id: $route.params.id },
      }"
      v-if="collectionPoint.voltageLevel === 'VN' && !collectionPoint.status && routeType"
    >
      <!--      <v-list-item-content>Aktualizace RSD VN </v-list-item-content>-->
      <v-list-item-content>Změna rezervované kapacity</v-list-item-content>
    </v-list-item>

    <v-list-item
      :to="{
        name: 'changeOfReservedCapacity.detail',
        params: { id: $route.params.id },
      }"
      v-if="collectionPoint.voltageLevel === 'VN' && !collectionPoint.status && !routeType"
    >
      <!--      <v-list-item-content>Aktualizace RSD VN </v-list-item-content>-->
      <v-list-item-content>Změna rezervované kapacity</v-list-item-content>
    </v-list-item>

    <v-list-item
      v-if="
        collectionPoint.allowedInstallationAction &&
          collectionPoint.allowedInstallationAction.name !== 'READING'
      "
      :to="{
        name: 'interruptionOrRenewalOfDistribution.detail',
        params: { id: $route.params.id },
      }"
    >
      <v-list-item-content>Přerušení / obnovení distribuce elektřiny</v-list-item-content>
    </v-list-item>

    <v-list-item
      :to="{
        name: 'trialOperation.detail',
        params: { id: $route.params.id },
      }"
      v-if="collectionPoint.voltageLevel === 'VN' && !collectionPoint.status"
    >
      <v-list-item-content>Zkušební provoz</v-list-item-content>
    </v-list-item>

    <v-list-item
      :to="{
        name: 'billingException.detail',
        params: { id: $route.params.id },
      }"
      v-if="collectionPoint.voltageLevel === 'VN' && !collectionPoint.status"
    >
      <v-list-item-content>Výjimka z fakturace</v-list-item-content>
    </v-list-item>

    <v-list-item
      :to="{
        name: 'requestNN.detail',
        params: { id: $route.params.id },
      }"
      v-if="
        collectionPoint.voltageLevel === 'NN' &&
        !collectionPoint.status &&
        isActiveProcess('REQUEST')"
    >
      <v-list-item-content>Žádost NN</v-list-item-content>
    </v-list-item>

    <v-list-item
      :to="{
        name: 'requestVN.detail',
        params: { id: $route.params.id },
      }"
      v-if="
        collectionPoint.voltageLevel === 'VN' &&
        !collectionPoint.status &&
        isActiveProcess('REQUEST')"
    >
      <v-list-item-content
        >Žádost VN</v-list-item-content
      >
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'RequestsMenu',
  props: {
    collectionPoint: {
      type: Object,
      default() {
        return {
          availableDistributionAction: {
            name: '',
            voltageLevel: '',
          },
        };
      },
      required: false,
    },
    routeType: {
      type: String,
      default: null,
      required: false,
    },
  },
  methods: {
    isActiveProcess(processName) {
      return process.env.VUE_APP_ACTIVE_PROCESSES.includes(processName);
    },
  },
};
</script>
